'use client';

import {useClpPurchaseContext} from '@/features/course-landing-page/context/clp-purchase-context.react-component';
import {useClpNoticeContext} from '@/features/course-landing-page/context/clp-notice-context-provider.react-component';
import {useClpSubscriptionContext} from '@/features/course-landing-page/context/clp-subscription-context.react-component';
import {
    PLAN_SELECTION_CHECKOUT_URL,
    PlanPeriodStyle,
    SubscriptionCTA,
    SubscribeFromPageCookie,
} from '@udemy-v2/react-subscription-browse';
import {useClpCourse} from '@/features/course-landing-page/context/clp-course-provider.react-component';
import styles from './subscription-sticky-footer-cta.module.scss';

export const SubscriptionStickyFooterCta = () => {
    const {unwrappedConsumerSubscriptionPlan, subscriptionCTAConfiguration, subscriptionTiersEnabled} =
        useClpPurchaseContext();
    const {isCourseInValuePlanCatalog, unwrappedPersonalPlan} = useClpSubscriptionContext();
    const clpNoticeContext = useClpNoticeContext();
    const course = useClpCourse();
    const subscriptionPriceBoxNotice = clpNoticeContext?.subscriptionPriceBoxNoticeData;
    // When subscription tiers are enabled, VP/Starter courses display PP pricing as the headline price
    // even though the CTA directs users to the plan selection page. This is a product decision to
    // surface the PP price as the primary offer on all subscription-eligible CLPs.
    const shouldSwapPlanForPrice =
        subscriptionTiersEnabled && isCourseInValuePlanCatalog && unwrappedPersonalPlan;

    const handleCtaClick = () => {
        SubscribeFromPageCookie.set('course_landing_page', parseInt(course.id, 10));
    };

    if (!unwrappedConsumerSubscriptionPlan) {
        return null;
    }

    return (
        <div data-testid="subscription-sticky-footer" data-purpose="subscription-sticky-footer">
            <SubscriptionCTA
                className={styles['subscription-cta']}
                uiRegion="subscription_sticky_footer"
                subtitleClassName={styles['cta-subtitle']}
                data-purpose="subscription-sticky-footer-button"
                offerCtaStyle="primary"
                onCTAClick={handleCtaClick}
                courseId={parseInt(course.id, 10)}
                includeTrialDaysOnCta={false}
                plan={shouldSwapPlanForPrice ? unwrappedPersonalPlan : unwrappedConsumerSubscriptionPlan}
                noticeData={
                    subscriptionCTAConfiguration?.upgradeUrl
                        ? {
                              ...subscriptionPriceBoxNotice,
                              cta_1_url: subscriptionCTAConfiguration.upgradeUrl,
                          }
                        : shouldSwapPlanForPrice
                          ? {
                                ...subscriptionPriceBoxNotice,
                                cta_1_url: `${PLAN_SELECTION_CHECKOUT_URL}?product_type=${unwrappedConsumerSubscriptionPlan.productType}`,
                            }
                          : subscriptionPriceBoxNotice
                }
                planPeriodStyle={PlanPeriodStyle.SINGLE}
                directCheckout={subscriptionCTAConfiguration?.directCheckout}
                selectPlanText={subscriptionCTAConfiguration?.selectPlanText}
                purchaseCtaText={subscriptionCTAConfiguration?.purchaseCtaText}
            />
        </div>
    );
};
